import React from 'react';
import './SplitViewLayout.css';

const SplitViewLayout = ({ leftContent, rightContent, leftTitle, rightTitle, orientation = 'horizontal' }) => {
    const orientationClass = orientation === 'vertical'
        ? 'split-view-layout--vertical'
        : 'split-view-layout--horizontal';

    return (
        <div className={`split-view-layout ${orientationClass}`}>
            <div className="split-pane left-pane">
                {leftTitle && <div className="split-pane-header">{leftTitle}</div>}
                <div className="split-pane-content">
                    {leftContent}
                </div>
            </div>
            <div className="split-divider"></div>
            <div className="split-pane right-pane">
                {rightTitle && <div className="split-pane-header">{rightTitle}</div>}
                <div className="split-pane-content">
                    {rightContent}
                </div>
            </div>
        </div>
    );
};

export default SplitViewLayout;
